import { render, staticRenderFns } from "./pushNotification.vue?vue&type=template&id=cd1532ba&scoped=true&"
import script from "./pushNotification.vue?vue&type=script&lang=js&"
export * from "./pushNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1532ba",
  null
  
)

export default component.exports